module.exports = "<i class=\"fa fa-wrench mr-1\" title=\"{{title}}\" style=\"color: orange;\"></i>\r\n"